import { Lucia } from "lucia";
import { Mysql2Adapter } from "@lucia-auth/adapter-mysql";
import mysql from "mysql2/promise";
import dotenv from "dotenv";
dotenv.config();
if (!process.env.DATABASE_URL) {
  throw new Error("Missing DATABASE_URL environment variable");
}
const pool = mysql.createPool({ uri: process.env.DATABASE_URL });
const adapter = new Mysql2Adapter(pool, {
  user: "User",
  // Prisma's default table name for the User model
  session: "user_session"
});
const lucia = new Lucia(adapter, {
  sessionCookie: {
    attributes: {
      secure: process.env.NODE_ENV === "production",
      sameSite: "lax",
      // httpOnly: true,
      path: "/"
    }
  },
  getUserAttributes: (attributes) => ({
    // Expose only safe fields
    email: attributes.email
  })
});
export {
  lucia as l
};
